<template>
  <div style="height: 90%" id="check-in" v-if="$store.state.user.settings">
    <mu-flexbox justify="center" align="center" style="height: 90%;">
      <mu-flexbox-item class="white content">
        <mu-row gutter>
          <mu-col width="100" tablet="10" desktop="10"></mu-col>
          <mu-col width="100" tablet="80" desktop="80">
            <router-view></router-view>
          </mu-col>
          <mu-col width="100" tablet="10" desktop="10"></mu-col>
        </mu-row>
      </mu-flexbox-item>
    </mu-flexbox>
    <mu-flexbox class="navigation">
      <mu-flexbox-item align="center">
        <div v-if="status.isDiabetic">
          <div class="oval left" v-bind:class="{active: $route.name === 'WeightCheckin'}"></div>
          <div class="oval left" v-bind:class="{active: $route.name === 'Hba1cCheckin'}"></div>
          <div class="oval" v-bind:class="{active: $route.name === 'GoalsCheckin'}"></div>
        </div>
        <div v-else>
          <div class="oval" v-bind:class="{active: $route.name === 'WeightCheckin'}"></div>
          <div class="oval left" v-bind:class="{active: $route.name === 'GoalsCheckin'}"></div>
        </div>
      </mu-flexbox-item>
    </mu-flexbox>
    <div class="footer">
      <div class="content">
        <mu-flat-button
          v-if="$route.name === 'WeightCheckin'"
          class="transparent"
          label="Skip"
          @click.native="determineRoute()"
        ></mu-flat-button>
        <mu-flat-button
          v-if="$route.name === 'Hba1cCheckin'"
          class="transparent"
          label="I don't know my HbA1c"
          @click.native="navigate('GoalsCheckin')"
        ></mu-flat-button>
      </div>
    </div>
  </div>
</template>
<script>

  import ScrollManager from "../../helpers/ScrollManager"
  import CheckInApi from "../../api/CheckIn"

  export default {
    data() {
      return {
        window: undefined,
        contentElement: undefined,
        stickyCheckTime: 300,
        stickyFooterInterval: undefined,
        status: {}
      }
    },
    mounted() {
      let self = this;
      self.contentElement = $('.main-content');
      self.window = $(window);
      self.stickyFooterInterval = setInterval(function () {
        if (self.window.outerWidth(true) >= 600) {
          $('.footer').attr('style',
            'width: ' + self.contentElement.prop("clientWidth") + 'px;' +
            'right: ' + ScrollManager.getScrollbarWidth() + 'px;');
        }
        else {
          $('.footer').attr('style', '');

        }
      }, self.stickyCheckTime);

      self.window.resize(function () {
        if (self.window.outerWidth(true) >= 600) {
          $('.footer').attr('style',
            'width: ' + self.contentElement.prop("clientWidth") + 'px;' +
            'right: ' + ScrollManager.getScrollbarWidth() + 'px;'
          );
        }
        else {
          $('.footer').attr('style', '');
        }
      });
      CheckInApi.getCheckInStatus()
        .then(function (response) {
          self.status = response.data;
        });
    },
    methods: {
      determineRoute() {
        if (this.status.isDiabetic) {
          this.$router.push({
            name: 'Hba1cCheckin'
          })
        }
        else {
          this.$router.push({
            name: 'GoalsCheckin'
          })
        }
      },
      navigate(name) {
        this.$router.push({
          name: 'GoalsCheckin'
        })
      }
    },
    beforeDestroy() {
      let self = this;
      clearInterval(self.stickyFooterInterval);
      //if user leaves the view, set session storage to ignore it
      //session storage allows data to be stored temporarily
      //when user nexts refreshes page or user returns the next day this property will be unset automatically
      window.sessionStorage.setItem('checkInIgnored', true);
    }
  }
</script>
<style lang="less">
  .oval.active {
    opacity: 1 !important;
  }

  #check-in {
    @media (max-width: 600px) {
      height: auto !important;
      .footer {
        position: static !important;
        background: transparent !important;
        text-align: center;
      }

      .bigTxt {
        text-align: center;
        font-size: 16px !important;
        margin-bottom: 16px !important;
      }

      .navigation {
        margin-top: 16px;
        margin-bottom: 16px;
      }
    }

    .oval.active {
      opacity: 1 !important;
    }

    .marker {
      width: 20px;
      height: 20px;
      background: #fa6956;
      transform: rotate(-45deg);
    }

    .oval {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      opacity: 0.4;
      background-color: #ffffff;
      display: inline-block;
    }
    .oval.left {
      margin-right: 4px;
    }
    button.mu-flat-button.transparent {
      color: white !important;
    }
    .footer {
      .content {
        padding: 8px;
      }
      bottom: 0;
      height: 50px;
      position: fixed;
      background: rgb(74, 172, 255);
    }

    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  @textColor: #0179d5;

  .checkIn {

    input.input.hasError {
      border: 1px solid #fa6956;
    }

    .shadow {
      box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.12);
    }
    input.input {
      padding: 0;
      -moz-appearance: textfield;
      &::placeholder {
        color: rgba(0, 0, 0, 0.4);
      }
      font-weight: 300;
      height: 116px;
      color: #656565;
      border: 1px solid #38272700;
      width: 100%;
      font-size: 36px;
      text-align: center;
    }
    .bigTxt.first {
      margin-bottom: 24px;
    }
    .bigTxt {
      font-size: 22px;
    }
    .lgTxt {
      font-size: 24px;
      color: #0179d5;
      margin-bottom: 16px;
      text-align: center;
    }
    .label {
      text-transform: lowercase;
      border-top: 1px solid #f5f5f5;
      padding-top: 4px;
      padding-bottom: 4px;
      color: #656565;
    }
    .pad {
      padding: 24px;
    }
  }
</style>



// WEBPACK FOOTER //
// Layout.vue?2225b8b0